import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from './SEO';
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FleetDetail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserFriends,
  faCouch,
  faSuitcaseRolling,
  faBriefcase,
  faShieldAlt,
  faCar,
  faGasPump,
  faSnowflake,
  faWifi,
  faMusic,
  faPhone,
  faMapMarkedAlt,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

const FleetSprinter = ({ currentLanguage }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Sprinter images for carousel
  const sprinterImages = [
    "/images/sprinter.avif",
    "/images/sprinter.avif", // You can add more Sprinter images here
    "/images/sprinter.avif",
  ];

  const vehicleData = {
    EN: {
      title: "Mercedes Sprinter Van",
      subtitle: "Spacious Luxury for Group Travel",
      description: "Our Mercedes Sprinter vans are the ultimate solution for group transportation. With premium amenities and spacious interiors, they're perfect for corporate events, family reunions, or group adventures.",
      specifications: {
        passengers: "Up to 14 Passengers",
        seats: "Executive Reclining Seats",
        largeLuggage: "8-12 Large Bags",
        carryOn: "14+ Carry-On Bags",
        fuelType: "Diesel Engine",
        transmission: "Automatic",
        airConditioning: "Rear & Front Climate Control",
      },
      features: [
        "Executive reclining seats",
        "Premium entertainment system",
        "Multiple USB charging ports",
        "LED ambient lighting",
        "Extra-large windows",
        "Professional sound system",
        "Refrigerated storage",
        "Professional driver service",
      ],
      perfectFor: [
        "Corporate group transportation",
        "Airport group transfers",
        "Wedding party transportation",
        "Sports team travel",
        "Family reunions and events",
        "City tours and excursions",
      ],
    },
    ES: {
      title: "Mercedes Sprinter Van",
      subtitle: "Lujo Espacioso para Viajes en Grupo",
      description: "Nuestras furgonetas Mercedes Sprinter son la solución definitiva para el transporte grupal. Con comodidades premium e interiores espaciosos, son perfectas para eventos corporativos, reuniones familiares o aventuras grupales.",
      specifications: {
        passengers: "Hasta 14 Pasajeros",
        seats: "Asientos Ejecutivos Reclinables",
        largeLuggage: "8-12 Maletas Grandes",
        carryOn: "14+ Equipajes de Mano",
        fuelType: "Motor Diésel",
        transmission: "Automático",
        airConditioning: "Control de Clima Trasero y Delantero",
      },
      features: [
        "Asientos ejecutivos reclinables",
        "Sistema de entretenimiento premium",
        "Múltiples puertos de carga USB",
        "Iluminación LED ambiental",
        "Ventanas extra grandes",
        "Sistema de sonido profesional",
        "Almacenamiento refrigerado",
        "Servicio de conductor profesional",
      ],
      perfectFor: [
        "Transporte corporativo grupal",
        "Traslados grupales al aeropuerto",
        "Transporte para fiestas de boda",
        "Viajes de equipos deportivos",
        "Reuniones familiares y eventos",
        "Tours de la ciudad y excursiones",
      ],
    },
    AR: {
      title: "مرسيدس سبرينتر فان",
      subtitle: "فخامة واسعة للسفر الجماعي",
      description: "تعتبر فانات مرسيدس سبرينتر لدينا الحل الأمثل للنقل الجماعي. مع وسائل الراحة المتميزة والتصميمات الداخلية الواسعة، فهي مثالية للأحداث المؤسسية أو لم شمل العائلة أو المغامرات الجماعية.",
      specifications: {
        passengers: "حتى 14 راكبًا",
        seats: "مقاعد تنفيذية قابلة للإمالة",
        largeLuggage: "8-12 حقيبة كبيرة",
        carryOn: "14+ حقيبة يد",
        fuelType: "محرك ديزل",
        transmission: "أوتوماتيكي",
        airConditioning: "تحكم مناخي خلفي وأمامي",
      },
      features: [
        "مقاعد تنفيذية قابلة للإمالة",
        "نظام ترفيه متميز",
        "منافذ شحن USB متعددة",
        "إضاءة LED محيطة",
        "نوافذ كبيرة جداً",
        "نظام صوتي احترافي",
        "تخزين مبرد",
        "خدمة سائق محترف",
      ],
      perfectFor: [
        "النقل الجماعي المؤسسي",
        "النقل الجماعي للمطار",
        "نقل حفلات الزفاف",
        "سفر الفرق الرياضية",
        "لم شمل العائلة والأحداث",
        "جولات المدينة والرحلات",
      ],
    },
  };

  const data = vehicleData[currentLanguage] || vehicleData.EN;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % sprinterImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + sprinterImages.length) % sprinterImages.length);
  };

  return (
    <>
      <SEO 
        title="Mercedes Sprinter Van Service | Large Group Transportation Jacksonville"
        description="Mercedes Sprinter van service in Jacksonville for large groups up to 14 passengers. Perfect for corporate events, weddings, airport transfers, and group tours."
        keywords="Mercedes Sprinter Jacksonville, large group transportation, 14 passenger van, corporate shuttle, wedding transportation, group tours"
        canonical="/fleet/sprinter"
      />
      <div className="fleet-detail-container">
        {/* Hero Section with Carousel */}
        <section className="fleet-detail-hero">
          <div className="fleet-carousel-container">
            <div className="fleet-carousel">
              <img
                src={sprinterImages[currentImageIndex]}
                alt="Mercedes Sprinter Van"
                className="fleet-detail-image"
              />
              <div className="fleet-carousel-overlay"></div>
              
              {/* Carousel Controls */}
            <button className="fleet-carousel-btn prev" onClick={prevImage}>
              <span>‹</span>
            </button>
            <button className="fleet-carousel-btn next" onClick={nextImage}>
              <span>›</span>
            </button>
            
            {/* Carousel Indicators */}
            <div className="fleet-carousel-indicators">
              {sprinterImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>
          
          {/* Hero Content */}
          <div className="fleet-hero-content">
            <h1 className="fleet-detail-title">{data.title}</h1>
            <p className="fleet-detail-subtitle">{data.subtitle}</p>
          </div>
        </div>
      </section>

      {/* Vehicle Details Section */}
      <section className="fleet-detail-content">
        <div className="container">
          <div className="row">
            {/* Description */}
            <div className="col-lg-8">
              <div className="fleet-description">
                <h2>About This Vehicle</h2>
                <p>{data.description}</p>
              </div>

              {/* Specifications */}
              <div className="fleet-specifications">
                <h3>Vehicle Specifications</h3>
                <div className="specs-grid">
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faUsers} className="spec-icon" />
                    <span>{data.specifications.passengers}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faCouch} className="spec-icon" />
                    <span>{data.specifications.seats}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSuitcaseRolling} className="spec-icon" />
                    <span>{data.specifications.largeLuggage}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faBriefcase} className="spec-icon" />
                    <span>{data.specifications.carryOn}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faGasPump} className="spec-icon" />
                    <span>{data.specifications.fuelType}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faCar} className="spec-icon" />
                    <span>{data.specifications.transmission}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSnowflake} className="spec-icon" />
                    <span>{data.specifications.airConditioning}</span>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="fleet-features">
                <h3>Premium Features</h3>
                <div className="features-grid">
                  {data.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <FontAwesomeIcon icon={faShieldAlt} className="feature-icon" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Perfect For Sidebar */}
            <div className="col-lg-4">
              <div className="fleet-sidebar">
                <div className="perfect-for-card">
                  <h3>Perfect For</h3>
                  <ul className="perfect-for-list">
                    {data.perfectFor.map((occasion, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faMapMarkedAlt} className="list-icon" />
                        {occasion}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Card */}
                <div className="fleet-cta-card">
                  <h4>Ready to Book?</h4>
                  <p>Premium group transportation solutions.</p>
                  <Link to="/ReservationForm" className="fleet-cta-btn">
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default FleetSprinter;
